import { useLocation } from 'react-router';
import { useHistory } from 'react-router-dom';
import { Tab } from '@signavio/ui';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
function LinkTab({
  children,
  icon,
  onClick,
  to,
  ...rest
}) {
  const location = useLocation();
  const history = useHistory();
  return /*#__PURE__*/_jsx(Tab, {
    icon: icon,
    onClick: () => {
      history.push(to);
      if (onClick) {
        onClick();
      }
    },
    active: location.pathname.startsWith(to),
    ...rest,
    children: children
  });
}
export default LinkTab;